import type { Scale } from 'chart.js'

const DAY_MS = 24 * 60 * 60 * 1000

const formatDay = new Intl.DateTimeFormat(undefined, {
  day: 'numeric',
  month: 'short'
}).format

/** A tooltip's title over a date axis: the day in full. */
export const formatChartDate = new Intl.DateTimeFormat(undefined, {
  dateStyle: 'medium'
}).format

/**
 * The x scale of a chart over whole days, given each point's timestamp (`chartTime`): a
 * `linear` axis, so no date adapter is needed, with a tick under every point.
 */
export function dateAxis(times: number[]) {
  const first = Math.min(...times)
  const last = Math.max(...times)
  // One point is a zero-width range, and the axis would spread it over a single instant.
  const pad = first === last ? DAY_MS : 0

  return {
    type: 'linear' as const,
    min: first - pad,
    max: last + pad,
    // A linear axis picks round numbers of milliseconds, and a fixed day's step slips an
    // hour at a DST change: the ticks are the points' own dates.
    afterBuildTicks: (axis: Scale) => {
      axis.ticks = times.map((value) => ({ value }))
    },
    ticks: { callback: (value: number | string) => formatDay(Number(value)) }
  }
}
